import { ACL_ROLES } from '../constants/misc';

export const isMemberAdmin = (member) => member.role === ACL_ROLES.ADMIN;

export const isMemberEditor = (member) => member.role === ACL_ROLES.EDITOR;

export const isMemberViewer = (member) => member.role === ACL_ROLES.USER;
